import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { tutorTrainingService } from "@data/services/tutorTrainingService"

const initialState = {
    // The current training step: title, video_url, embed_url, duration.
    step: null,
    // The quiz, choices shuffled by the server on every read, no answers key.
    questions: [],
    passThresholdPercent: 80,
    // not_started | failed | passed, with the score and the failure count.
    progress: null,
    // The graded last attempt: score, verdict per question, valid answers.
    lastResult: null,
}

export function tutorTraining(state = initialState, action) {
    switch (action.type) {
        case tutorTrainingService.getTutorTraining.name + apiConstants._SUCCESS:
            return {
                ...state,
                step: action.data?.training_step ?? null,
                questions: action.data?.questions ?? [],
                passThresholdPercent:
                    action.data?.pass_threshold_percent ??
                    state.passThresholdPercent,
                progress: action.data?.progress ?? null,
                lastResult: null,
            }

        case tutorTrainingService.submitTutorTrainingQuiz.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                progress: action.data?.progress ?? state.progress,
                lastResult: action.data ?? null,
            }

        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}
